/**
 * Centralized debug logging utility that only logs in debug mode
 * Logs are shown in:
 * - Lovable environment (lovable.app, lovable.dev domains)
 * - When debug=true parameter is set
 * - In development environment
 * Logs are hidden in production/live mode
 */

// Check if we're in debug mode
const isDebugMode = (): boolean => {
  // Check if running in development
  if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
    return true;
  }
  
  // Check if running in Lovable environment
  if (typeof window !== 'undefined') {
    const isInLovable = window.location.hostname.includes('lovable.app') || 
                        window.location.hostname.includes('lovable.dev') || 
                        (typeof document !== 'undefined' && 
                         (document.referrer.includes('lovable.app') || document.referrer.includes('lovable.dev'))) ||
                        window.location.search.includes('lovable_preview=true');
    
    // Check for debug parameter in URL
    const queryParams = new URLSearchParams(window.location.search);
    const debugParam = queryParams.get('debug');
    
    // Debug mode is enabled if:
    // - Explicitly set via URL parameter, OR
    // - Running on a Lovable domain AND not explicitly disabled
    return debugParam === 'true' || (isInLovable && debugParam !== 'false');
  }
  
  return false;
};

/**
 * Debug logger that only logs when in debug mode
 */
export const debugLogger = {
  log: (...args: any[]) => {
    if (isDebugMode()) {
      console.log(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDebugMode()) {
      console.error(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDebugMode()) {
      console.warn(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDebugMode()) {
      console.info(...args);
    }
  }
};